







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StepDivider extends Vue {
  @Prop({ type: Boolean, default: false }) private isDone!: boolean;
}
